<template>
  <a-modal
    title="Dodaj aplikacje"
    width="40vw"
    wrapClassName="modal-wrapper"
    v-model="visible"
    @ok="onSubmit"
    @cancel="closeModal"
    okText="Zapisz"
    cancelText="Anuluj"
  >
    <form-wrapper
      ref="form"
      :service="Application"
      :formComponent="InnerForm"
      :form.sync="form"
      :errors.sync="errors"
      :objParams="objParams"
      :edited="edited"
      success-message="Aplikacja dodana"
      edited-message="Zmiany zapisane"
      @formSubmitted="success"
    />
  </a-modal>
</template>
<script>
import InnerForm from './InnerForm'
import { Application } from '@/api'

export default {
  data() {
    return {
      form: {},
      errors: {},
      visible: false,
      objParams: null,
      edited: false,
      Application,
      InnerForm
    }
  },
  methods: {
    onSubmit() {
      this.$refs.form.onSubmit()
    },
    openModal({ lecturerId, studentId, instanceId }) {
      this.edited = !!instanceId

      if (instanceId) {
        this.objParams = instanceId
      } else {
        this.form = {
          user: lecturerId || studentId
        }
      }
      this.visible = true
    },
    success() {
      this.closeModal()
      this.$emit('formSubmitted')
    },
    closeModal() {
      this.resetForm()
      this.visible = false
    },
    resetForm() {
      this.objParams = null
      this.form = {}
      this.errors = {}
    }
  }
}
</script>
